// export const API = 'http://localhost:8000/api/v1'
export const API = 'https://getartbackend.devdas.tech/api/v1'
// export const API = 'http://143.110.242.244:8000/api/v1'
// export const API = 'https://3a72-103-49-116-79.in.ngrok.io/api/v1'